<div class="modal-header no-icon">
    <h3 class="modal-title pull-left">Mission Calendar</h3>
    <button
        type="button"
        class="close pull-right"
        aria-label="Close"
        (click)="hide()"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body no-footer">
    <div class="modal-body-content vertical-container">
        <plan-highlight
            [featureFlags]="missionCalendarFeature"
        ></plan-highlight>
        <div class="calendar-heading">
            <div class="button-group">
                <div
                    class="btn btn-circle btn-link left-buffer right-buffer"
                    mwlCalendarPreviousView
                    [view]="view"
                    [(viewDate)]="viewDate"
                    (viewDateChange)="closeOpenMonthViewDay()"
                >
                    <span class="fa fa-arrow-left"></span>
                </div>
                <div
                    class="btn btn-sm btn-pill left-buffer right-buffer"
                    mwlCalendarToday
                    [(viewDate)]="viewDate"
                    (viewDateChange)="closeOpenMonthViewDay()"
                >
                    Today
                </div>
                <div
                    class="btn btn-circle btn-link left-buffer right-buffer"
                    mwlCalendarNextView
                    [view]="view"
                    [(viewDate)]="viewDate"
                    (viewDateChange)="closeOpenMonthViewDay()"
                >
                    <span class="fa fa-arrow-right"></span>
                </div>
            </div>
            <h4>{{ viewDate | calendarDate: view + 'ViewTitle':'en' }}</h4>
            <div class="left-buffer">
                <mat-slide-toggle
                    [(ngModel)]="showNotices"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="toggleNotices()"
                >
                    Show LOTAMs
                </mat-slide-toggle>
            </div>
            <!-- <div class="view-buttons">
                <button
                    type="button"
                    class="btn btn-sm right-buffer"
                    [ngClass]="{
                        'btn-primary': view === CalendarView.Week,
                        'btn-default': view === CalendarView.Month
                    }"
                    (click)="setView(CalendarView.Week)"
                >
                    Week View
                </button>
                <button
                    type="button"
                    class="btn btn-sm right-buffer"
                    [ngClass]="{
                        'btn-primary': view === CalendarView.Month,
                        'btn-default': view === CalendarView.Week
                    }"
                    (click)="setView(CalendarView.Month)"
                >
                    Month View
                </button>
            </div> -->
        </div>
        <div class="fill container-scroll">
            <ng-container [ngSwitch]="view">
                <mwl-calendar-month-view
                    *ngSwitchCase="CalendarView.Month"
                    [viewDate]="viewDate"
                    [events]="events$ | async"
                    [refresh]="refresh"
                    [cellTemplate]="customMonthCellTemplate"
                >
                </mwl-calendar-month-view>
                <!-- <mwl-calendar-week-view
                *ngSwitchCase="CalendarView.Week"
                [viewDate]="viewDate"
                [events]="events"
                [refresh]="refresh"
                [eventTemplate]="customWeekEventTemplate"
            ></mwl-calendar-week-view> -->
            </ng-container>
        </div>
    </div>
</div>

<ng-template #customMonthCellTemplate let-day="day" let-locale="locale">
    <div class="cal-cell-top">
        <span class="cal-day-number">{{
                day.date | calendarDate: 'monthViewDayNumber':locale
            }}</span>
    </div>

    <ng-container *ngIf="showNotices">
        <ng-container *ngIf="lotamsByDay.get(getDayKey(day.date)) as lotamEvents">
            <div class="cal-event-container">
                <!-- LOTAM section — shown above missions when toggle is on -->
                <ng-container
                    *ngFor="let event of lotamEvents; let i = index"
                >
                    <ng-template #lotamTip>
                        <div *ngIf="event.start">
                            From: {{ event.start | formatDate }}
                        </div>
                        <div *ngIf="event.end">
                            To: {{ event.end | formatDate }}
                        </div>
                        <div>
                            Lower: {{ event.lowerLimit | formatAltitudeValue: 'SFC' }}
                        </div>
                        <div>
                            Upper:
                            {{ event.upperLimit | formatAltitudeValue: 'Unlimited' }}
                        </div>
                    </ng-template>
                    <div class="vertical-container bottom-buffer" *ngIf="i < 3">
                        <a
                            class="horizontal-container vertical-align"
                            (click)="openLotamEvent(event)"
                            [tooltip]="lotamTip"
                            [adaptivePosition]="true"
                        >
                            <notice-type-colour
                                [colour]="event.noticeTypeColour ?? '#808080'"
                            ></notice-type-colour>
                            <span [innerHTML]="event.truncatedSubject | formatEmptyTitle | unsafeHtml"></span>
                        </a>
                    </div>
                    <div class="vertical-container" *ngIf="i === 3">
                        <span
                        >&amp;
                            {{ lotamEvents.length - 3 }}
                            more...</span
                        >
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <div class="top-buffer"></div>
    </ng-container>

    <ng-container *ngIf="missionsByDay.get(getDayKey(day.date)) as missionEvents">
        <div class="cal-event-container">
            <!-- Mission section -->
            <ng-container
                *ngFor="let event of missionEvents; let i = index"
            >
                <ng-template #missionTip>
                    <div>
                        {{ event.time }} - {{ event.status | formatMissionStatus }}
                    </div>
                    <div *ngIf="event.rpic">
                        RPIC: {{ event.rpic | formatPerson }}
                    </div>
                    <div *ngIf="event.rpaNames?.length">
                        RPA: {{ event.rpaNames | join }}
                    </div>
                </ng-template>
                <div class="vertical-container bottom-buffer" *ngIf="i < 3">
                    <mission-status-icon
                        [mission]="event"
                        [tooltip]="missionTip"
                        [adaptivePosition]="true"
                        (nameClicked)="openEvent(event)"
                    ></mission-status-icon>
                </div>
                <div class="vertical-container" *ngIf="i === 3">
                    <span
                    >&amp;
                        {{ missionEvents.length - 3 }}
                        more...</span
                    >
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<!-- <ng-template #customWeekEventTemplate let-column="column" let-locale="locale">
    <div class="cal-event-container bottom-buffer">
        <ng-container
            *ngFor="let timeEvent of column.events; let i = index;"
            #event
        >
            <div class="vertical-container" *ngIf="i === 0">
                <div class="event-heading bottom-buffer">{{ timeEvent.event.locationName }} - {{ timeEvent.event.status | formatMissionStatus }}</div>
                <div><strong>RPIC: </strong>{{ timeEvent.event.rpic | formatPerson }}</div>
                <div><strong>RPA: </strong>{{ timeEvent.event.rpaNames | join }}</div>
                <span *ngIf="column.events.length > 1" class="pull-right" (click)="showEvents(column.events)">and {{ column.events.length - 1 }} more...</span>
            </div>
        </ng-container>
    </div>
</ng-template> -->
